import { FC } from "react"
import classNames from "classnames"
import "./index.scss"

export enum SpinnerSize {
   SMALL = "--sm",
   MEDIUM = "--md",
   LARGE = "--lg",
}

export interface SpinnerProps {
   size?: SpinnerSize
}

const Spinner: FC<SpinnerProps> = ({ size = SpinnerSize.MEDIUM }) => {
   return <div className={classNames("spinner", `spinner${size}`)} />
}

export default Spinner
